import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { assinaturaService } from "../services/api";

const Assinatura = () => {
  const [planos, setPlanos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [loadingPlano, setLoadingPlano] = useState(null);

  useEffect(() => {
    const fetchPlanos = async () => {
      try {
        const response = await assinaturaService.getPlanos();
        setPlanos(response);
      } catch (err) {
        setError(
          "Não foi possível carregar os planos. Tente novamente mais tarde.",
        );
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchPlanos();
  }, []);

  const handleAssinar = async (planoId) => {
    setLoadingPlano(planoId);
    try {
      const response = await assinaturaService.createCheckoutSession(planoId);
      const { url } = response.data;
      // Redireciona o usuário para a página de pagamento da Stripe
      window.location.href = url;
    } catch (err) {
      setError(
        err.response?.data?.error ||
          "Erro ao iniciar o processo de assinatura.",
      );
      console.error(err);
      setLoadingPlano(null);
    }
  };

  const formatPrice = (price) => {
    return (price / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ minWidth: 0, overflow: "hidden" }}>
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
        Planos de Assinatura
      </Typography>
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}
      <Grid
        container
        spacing={4}
        wrap="wrap"
        sx={{ minWidth: 0, overflow: "hidden" }}
      >
        {planos.map((plano) => (
          <Grid item key={plano.id} xs={12} md={4} sx={{ minWidth: 0 }}>
            <Card
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                minWidth: 0,
              }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h5" component="div" sx={{ mb: 2 }}>
                  {plano.nome}
                </Typography>
                <Typography variant="h4" color="primary" sx={{ mb: 2 }}>
                  {formatPrice(plano.preco_centavos)}
                  <Typography
                    variant="body1"
                    component="span"
                    color="text.secondary"
                  >
                    /{plano.intervalo === "month" ? "mês" : "ano"}
                  </Typography>
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Descrição breve do plano. Ideal para escritórios que buscam
                  simplicidade e eficiência.
                </Typography>
              </CardContent>
              <Box sx={{ p: 2 }}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handleAssinar(plano.id)}
                  disabled={loadingPlano === plano.id}
                >
                  {loadingPlano === plano.id ? (
                    <CircularProgress size={24} />
                  ) : (
                    "Assinar Agora"
                  )}
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Assinatura;
